import { useMemo } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useFetch } from "../../core/hooks/useFetch";
import { IMaquininha } from "../interface/IMaquininha";

/**
 * @param apenasAtivas usar `true` nos selects de pagamento, para não oferecer maquininhas
 * que saíram de uso; a tela de cadastro lista todas.
 */
export const useFetchMaquininhas = (apenasAtivas?: boolean) => {
    const api = useMemo(() => ApiFactory.getApi("MS_PEDIDOS"), []);
    const url = apenasAtivas ? '/maquininhas?ativo=true' : '/maquininhas';

    const { data, error, isLoading, mutate } = useFetch<IMaquininha[]>(api, url);

    return { maquininhas: data ?? [], error, isLoading, mutate };
}
